// services/axiosInstance.js
import axios from 'axios';

// Determine the base URL based on the environment
// const getBaseUrl = () => {
//   const isProduction = process.env.NODE_ENV === 'production';

//   if (isProduction) {
//     return 'http://3.110.159.35:5000'; // render Production URL
//   } else if (window.location.hostname === 'localhost') {
//     return 'http://localhost:5000'; // Local Development
//   } 
//   // else {
//   //   return 'https://stockkhata-webapp.onrender.com'; // EC2 Public IP
//   // }
// };

const getBaseUrl = () => {
  const isProduction = process.env.NODE_ENV === 'production';
  
  if (isProduction) {
    // Use primary backend for all production environments
    return 'https://stockkhata-webapp.onrender.com';
  } else if (window.location.hostname === 'localhost') {
    return 'http://localhost:5000'; // Local development
  }
  
  // Fallback for other cases
  return 'https://stockkhata-webapp.onrender.com';
};

// Create axios instance
const baseURL = getBaseUrl();
console.log('🔗 Axios configured with baseURL:', baseURL);
console.log('🌐 Current hostname:', window.location.hostname);
console.log('🏭 Environment:', process.env.NODE_ENV);

const axiosInstance = axios.create({
    baseURL: baseURL,
    timeout: 30000, // Increased from 10000 to 30000 (30 seconds)
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add authorization token (skip for login)
axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.url.includes('/auth/login')) { // Skip token for login
      // Check for admin token first, then regular token
      const adminToken = localStorage.getItem('adminToken');
      const token = localStorage.getItem('token');
      
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      } else if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('adminToken');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;